/* Set builder, screen reader and keyboard support.
   1. The small set tiles in the phone bar get spoken names (remove an item / go to a step).
   2. A change of step is announced ("Step 2 / 5: Add your bottom"), and so is the moment the set discount is unlocked.
   3. After a pick or a skip made from the keyboard, focus moves to the heading of the next step instead of being lost. */
(function () {
  'use strict';
  function init() {
    var section = document.querySelector('[data-mt-bundle-builder]');
    if (!section) return;
    var titles = [];
    try {
      titles = JSON.parse(section.querySelector('[data-mt-bb-slots]').textContent).map(function (s) { return s.title; });
    } catch (e) {}

    var box = section.querySelector('[data-mt-bb-minitiles]');
    function nameMinis() {
      if (!box) return;
      box.querySelectorAll('[data-mt-bb-tile]').forEach(function (b) {
        var i = parseInt(b.getAttribute('data-mt-bb-tile'), 10);
        var t = titles[i] || ('step ' + (i + 1));
        var label = b.classList.contains('mt-filled') ? 'Remove ' + t + ' from your set' : 'Go to step: ' + t;
        if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
      });
    }
    if (box && window.MutationObserver) new MutationObserver(nameMinis).observe(box, { childList: true });
    nameMinis();

    var live = document.createElement('div');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    section.appendChild(live);
    function say(text) { live.textContent = ''; setTimeout(function () { live.textContent = text; }, 60); }

    var head = section.querySelector('[data-mt-bb-stepheading]');
    var kicker = section.querySelector('[data-mt-bb-steplabel]');
    var lastTitle = head ? head.textContent : '';
    var keyboard = false;
    document.addEventListener('keydown', function (e) { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') keyboard = true; }, true);
    document.addEventListener('pointerdown', function () { keyboard = false; }, true);
    if (head && window.MutationObserver) {
      new MutationObserver(function () {
        var now = head.textContent;
        if (now === lastTitle) return;
        lastTitle = now;
        say((kicker ? kicker.textContent.replace(/\s+/g, ' ').trim() + ': ' : '') + now);
        if (keyboard) {
          head.setAttribute('tabindex', '-1');
          try { head.focus({ preventScroll: false }); } catch (e) { head.focus(); }
        }
      }).observe(head, { childList: true, characterData: true, subtree: true });
    }

    var disc = section.querySelector('.mt-bb__row--disc');
    if (disc && window.MutationObserver) {
      var wasOk = disc.classList.contains('mt-ok');
      new MutationObserver(function () {
        var ok = disc.classList.contains('mt-ok');
        if (ok && !wasOk) say('Set discount unlocked.');
        wasOk = ok;
      }).observe(disc, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();